// services/AdminPortal/payslipAPI.js
import axios from "axios";

const API_URL = "https://dashboard.lono.co.in/api/payslips"; // adjust base URL if needed

// ➕ Create Payslip
export const createPayslip = async (payload) => {
  const { data } = await axios.post(API_URL, payload);
  return data;
};

// 📑 Get all Payslips
export const getPayslips = async () => {
  const { data } = await axios.get(API_URL);
  return data;
};

// 🔍 Get Payslip by ID
export const getPayslipById = async (id) => {
  const { data } = await axios.get(`${API_URL}/${id}`);
  return data;
};

// ✏️ Update Payslip by ID
export const updatePayslipById = async (id, payload) => {
  const { data } = await axios.put(`${API_URL}/${id}`, payload);
  return data;
};

// ⬇️ Download Payslip as PDF
export const downloadPayslipPDF = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/download`, {
    responseType: "blob", // important for files
  });

  // Create blob link to download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `payslip-${id}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
